import projectImg_1 from "../../assets/images/projects/projects-1.jpg"
import projectImg_2 from "../../assets/images/projects/projects-2.jpg"
import projectImg_3 from "../../assets/images/projects/projects-3.jpg"
import projectImg_4 from "../../assets/images/projects/projects-4.jpg"
import projectImg_5 from "../../assets/images/projects/projects-5.jpg"

export  const projectData = [
    {
        id: 1,
        project_name: "Data Loss Prevention (DLP)",
        details: "This includes implementing strategies and tools to prevent sensitive data...",
        src: projectImg_1
    },
    {
        id: 2,
        project_name: "Data Loss Prevention (DLP)",
        details: "This includes implementing strategies and tools to prevent sensitive data...",
        src: projectImg_2
    },
    {
        id: 3,
        project_name: "Data Loss Prevention (DLP)",
        details: "This includes implementing strategies and tools to prevent sensitive data...",
        src: projectImg_3
    },
    {
        id: 4,
        project_name: "Data Loss Prevention (DLP)",
        details: "This includes implementing strategies and tools to prevent sensitive data...",
        src: projectImg_4
    },
    {
        id: 5,
        project_name: "Data Loss Prevention (DLP)",
        details: "This includes implementing strategies and tools to prevent sensitive data...",
        src: projectImg_5
    },

]